import React, { useEffect, useState } from 'react';
import { CheckCircle2, CrownIcon } from 'lucide-react';
const NAMES = ['María', 'Lucas', 'Carolina', 'Andrea', 'Roberto', 'Valentina', 'Martín', 'Sofía', 'Diego', 'Camila', 'Fernanda', 'Alejandro', 'Gabriela', 'José', 'Paola'];
const COUNTRIES = ['Buenos Aires 🇦🇷', 'Ciudad de México 🇲🇽', 'Bogotá 🇨🇴', 'Lima 🇵🇪', 'Santiago 🇨🇱', 'Montevideo 🇺🇾', 'Quito 🇪🇨', 'Guadalajara 🇲🇽', 'Medellín 🇨🇴', 'Córdoba 🇦🇷', 'San José 🇨🇷', 'Panamá 🇵🇦', 'Santo Domingo 🇩🇴', 'Asunción 🇵🇾', 'La Paz 🇧🇴'];
const PRODUCT = 'Pack Completo Familia';
export function SocialProofPopup() {
  const [mounted, setMounted] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    country: '',
    product: ''
  });
  // Defer mounting until after initial paint
  useEffect(() => {
    const mountTimer = setTimeout(() => setMounted(true), 4000);
    return () => clearTimeout(mountTimer);
  }, []);
  useEffect(() => {
    if (!mounted) return;
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCountry = COUNTRIES[Math.floor(Math.random() * COUNTRIES.length)];
      setCurrentPurchase({
        name: randomName,
        country: randomCountry,
        product: PRODUCT
      });
      setIsVisible(true);
      setTimeout(() => setIsVisible(false), 4000);
    };
    const initialTimer = setTimeout(showPopup, 1000);
    const interval = setInterval(() => {
      showPopup();
    }, Math.floor(Math.random() * 4000) + 8000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, [mounted]);
  if (!mounted) return null;
  const isCompleto = currentPurchase.product === 'Pack Completo Familia';
  return <div className={`fixed bottom-4 left-4 z-50 max-w-[280px] md:max-w-sm rounded-lg shadow-lg p-3 md:p-4 flex items-start gap-2 md:gap-3 transition-all duration-300 ${isCompleto ? 'bg-yellow-50 border-2 border-yellow-400' : 'bg-white border border-gray-200'}`} style={{
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? 'translateX(0)' : 'translateX(-120%)',
    pointerEvents: isVisible ? 'auto' : 'none',
    contain: 'layout style'
  }} data-id="element-248">
      <div className="mt-0.5 flex-shrink-0" data-id="element-249">
        {isCompleto ? <CrownIcon className="w-5 h-5 md:w-6 md:h-6 text-yellow-500" data-id="element-250" /> : <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-green-500" data-id="element-251" />}
      </div>
      <div data-id="element-252">
        <p className="text-xs md:text-sm text-gray-800" data-id="element-253">
          <span className="font-bold" data-id="element-254">{currentPurchase.name}</span> de{' '}
          <span className="font-bold" data-id="element-255">{currentPurchase.country}</span> acaba de
          comprar el
        </p>
        <p className={`text-xs md:text-sm font-bold mt-1 ${isCompleto ? 'text-yellow-600' : 'text-blue-600'}`} data-id="element-256">
          {isCompleto && '🏆 '}
          {currentPurchase.product}!
        </p>
        <p className="text-[10px] md:text-xs text-gray-400 mt-0.5" data-id="element-257">
          Hace unos segundos
        </p>
      </div>
    </div>;
}